export default class CustomSelect {
    constructor(select) {
        this.select = select;
        this.selectWrapper = document.createElement('div');
        this.selectWrapper.classList.add('custom-select-wrapper');
        this.customSelected = document.createElement('div');
        this.customSelected.classList.add('custom-select-selected');
        // Chevron svg
        const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svgIcon.setAttribute('width', '27.4');
        svgIcon.setAttribute('height', '40');
        svgIcon.setAttribute('viewBox', '0 0 27.4 40');
        svgIcon.setAttribute('fill', 'none');
        const svgPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        svgPath.setAttribute('fill', 'currentColor');
        svgPath.setAttribute('d', 'M17.3 20L0 0h9.9l17.5 20L9.9 40H0z');
        svgIcon.appendChild(svgPath);
        this.customSelected.innerHTML = `<span>${this.select.options[this.select.selectedIndex].textContent}</span>`;
        this.customSelected.appendChild(svgIcon);
        this.customDropdown = document.createElement('div');
        this.customDropdown.classList.add('custom-select-dropdown');
        this.customOptions = document.createElement('ul');
        this.createCustomOptions();
        this.customDropdown.appendChild(this.customOptions);
        this.selectWrapper.appendChild(this.customSelected);
        this.selectWrapper.appendChild(this.customDropdown);
        // Container for the select and the custom dropdown
        this.customContainer = document.createElement('div');
        this.customContainer.classList.add('custom-select-container');
        this.select.parentNode.insertBefore(this.customContainer, this.select);
        // if this.select has data-js-select attribute and is not empty - assign it to customContainer
        if (this.select.dataset.jsSelect) {
            this.customContainer.setAttribute(this.select.dataset.jsSelect, '');
        }
        this.customContainer.appendChild(this.select);
        this.customContainer.appendChild(this.selectWrapper);
        const label = this.customContainer.parentElement;
        if (label) {
            label.classList.add('custom-select-label');
        }
        this.init();
    }
    init() {
        // Toggle the dropdown when clicking the selected option
        this.select.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevent click event from bubbling up to the document level
            this.selectWrapper.classList.toggle('active');
        });
        this.select.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.stopPropagation(); // Prevent click event from bubbling up to the document level
                event.preventDefault();
                this.selectWrapper.classList.toggle('active');
            }
        });
        const handleOutsideClick = (event) => {
            const target = event.target;
            // Check if the click is outside the select wrapper
            if (!this.selectWrapper.contains(target)) {
                this.selectWrapper.classList.remove('active');
                // Remove the event listener after handling the click outside
                document.removeEventListener('click', handleOutsideClick);
            }
        };
        document.addEventListener('click', handleOutsideClick.bind(this));
        // Handle custom option clicks
        this.customOptions.addEventListener('click', (e) => {
            const target = e.target;
            this.customDropdown.querySelectorAll('li').forEach(li => {
                li.classList.remove('selected');
            });
            if (target && target.tagName === 'LI') {
                this.selectOption(target.dataset.value, target.textContent);
                target.classList.add('selected');
            }
        });
    }
    createCustomOptions() {
        Array.from(this.select.options).forEach(option => {
            const li = document.createElement('li');
            li.dataset.value = option.value;
            li.textContent = option.text;
            if (option.selected) {
                li.classList.add('selected');
            }
            this.customOptions.appendChild(li);
        });
    }
    selectOption(value, text) {
        // Update the original select value
        this.select.value = value;
        this.customSelected.querySelector('span').textContent = text;
        this.customDropdown.classList.remove('active');
        this.select.querySelectorAll('option').forEach(option => {
            option.removeAttribute('selected');
        });
        this.select.querySelector(`option[value="${value}"]`).setAttribute('selected', 'selected');
    }
}
